import { PrivateInterceptor } from "../../interceptors/PrivateInterceptor";

export const sendEmailInscripcionCliente = async(objeto) =>{
    const result = await PrivateInterceptor('Base/Clientes/EnviarCorreoInscripcion', 'POST', objeto)
    return result
}
